import styled from "styled-components";

import { breakpoints } from "../../../constants/breakpoints";

export const Wrap = styled.div`
  /* Mobile / default */

  padding: calc(var(--space-unit) * 2) 0;

  & z-input {
    font-size: 14px;
    margin-bottom: calc(var(--space-unit) * 1.5);
  }

  /* Tablet breakpoint */
  @media only screen and (min-width: ${breakpoints.tablet}px) {
    padding: calc(var(--space-unit) * 5) 0;
  }

  /* Desktop breakpoint */
  @media only screen and (min-width: ${breakpoints.desktop}px) {
  }

  /* Desktop Wide breakpoint */
  @media only screen and (min-width: ${breakpoints.desktopWide}px) {
  }
`;
